<template>
    <router-link class='resourceTile cs-cerulean' :to="detailLink">
        <div class='resourceTileInner'>
        <img :src='thumbnail'>
        <div class='resourceText'><h2>{{resource.title}}</h2><h3> </h3></div>
        <div class='resourceTags'><router-link v-if='tag.showOnTiles' :to="{ name: 'resourcesearch', query: { tag: tag.title } }" class='tag' v-for='tag in resource.tags' :key='tag.title'>{{tag.title}}</router-link></div>
        <img class='resourceType' v-if='resource.type=="YouTube"' :src='require("../assets/youtube_social_icon_red.png").default'>
        </div>
    </router-link>
</template>

<script>
import util from '../util'

export default {
    name: 'youtube-tile',
    props: ['resource'],
    computed: {
        detailLink() {
            return { name: 'resourcedetail', params: { resource: this.resource, slug: this.resource.slug } };
        },
        thumbnail() {
            if (this.resource.image) {
                return this.resource.thumbnail.url;
            } else {
                return `//i3.ytimg.com/vi/${util.videoId(this.resource.url)}/mqdefault.jpg`;
            }
        }
    }
}
</script>